import logo from "@/assets/logo-sr.png";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  alt?: string;
  wrapperClassName?: string;
  imgClassName?: string;
  loading?: "eager" | "lazy";
}

const BrandLogo = ({
  alt = "SR Software",
  wrapperClassName,
  imgClassName,
  loading = "eager",
}: BrandLogoProps) => {
  return (
    <span className={cn("inline-flex aspect-square overflow-hidden rounded-full", wrapperClassName)}>
      <img
        src={logo}
        alt={alt}
        loading={loading}
        decoding="async"
        className={cn("h-full w-full object-cover scale-[1.05]", imgClassName)}
      />
    </span>
  );
};

export default BrandLogo;
